import Hero from './components/Hero';
import Angebote from './components/Angebote';
import CTA from './components/CTA';
import Kontakt from './components/Kontakt';
import AGB from './components/AGB';
import Datenschutz from './components/Datenschutz';

export default function Home() {
  return (
    <div className="bg-white">
      <Hero />
      <Angebote />
      <CTA />
      <Kontakt />
      <AGB />
      <Datenschutz />
    </div>
  );
}
